var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.$t('bioSearch.title'))}}),_c('v-card-subtitle',{domProps:{"textContent":_vm._s(_vm.$t('bioSearch.subtitle'))}}),_c('bio-search-input',{attrs:{"redirect":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }